export default function About() {
  return (
    <section className="py-12 md:py-16 max-w-6xl mx-auto px-5 md:px-8">
      {/* Heading */}
      <div className="text-center mb-10 md:mb-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 tracking-tight">
          About <span className="text-primary">KrioGym</span>
        </h2>
        <p className="text-slate-400 text-base md:text-lg max-w-3xl mx-auto leading-relaxed">
          Ludhiana's premier fitness destination — where discipline meets results
          and every rep counts.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        {/* Left Content */}
        <div className="space-y-6 md:space-y-8">
          <p className="text-slate-300 text-base md:text-lg leading-relaxed">
            KrioGym is built for those who train with purpose. We combine modern
            equipment, experienced trainers, and a motivating environment to
            help you achieve real, sustainable fitness results.
          </p>

          {/* Highlights with SVG Icons */}
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Premium Equipment */}
            <li className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 6v12m6-12v12M4 10h16M4 14h16"
                  />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-white">
                  Premium Equipment
                </h4>
                <p className="text-slate-400 text-sm">
                  Latest machines & free weights
                </p>
              </div>
            </li>

            {/* Community */}
            <li className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17 20h5v-2a4 4 0 00-5-4m-6 6H2v-2a4 4 0 015-4m6-4a4 4 0 11-8 0 4 4 0 018 0zm6 4a3 3 0 10-6 0"
                  />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-white">
                  Strong Community
                </h4>
                <p className="text-slate-400 text-sm">
                  Support & motivation every day
                </p>
              </div>
            </li>

            {/* Safety */}
            <li className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 3l8 4v5c0 5-3.5 9.7-8 11-4.5-1.3-8-6-8-11V7l8-4z"
                  />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-white">Safe & Clean</h4>
                <p className="text-slate-400 text-sm">
                  Hygiene & safety first
                </p>
              </div>
            </li>

            {/* Trainers */}
            <li className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-primary/10 text-primary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-7 w-7"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0v6"
                  />
                </svg>
              </div>
              <div>
                <h4 className="font-semibold text-white">
                  Expert Trainers
                </h4>
                <p className="text-slate-400 text-sm">
                  Certified & goal-oriented coaching
                </p>
              </div>
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="relative rounded-2xl overflow-hidden border border-slate-700/50 shadow-xl group">
          <img
            src="https://images.unsplash.com/photo-1605296867304-46d5465a13f1?auto=format&fit=crop&w=1200&q=80"
            alt="KrioGym Training Floor"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <p className="text-white font-bold text-xl md:text-2xl">
              Your Journey Starts Here
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}


// export default function About() {
//   return (
//     <section className="py-8 max-w-xl mx-auto px-5">
//       <h2 className="text-xl font-bold text-white mb-3">About KrioGym</h2>
//       <p className="text-slate-300 text-sm leading-relaxed mb-4">
//         KrioGym Ludhiana Punjab ka pehla completely <span className="text-primary font-semibold">free access</span> gym hai. 
//         Yahan koi membership, koi monthly fees nahi — bas aao, train karo aur fit raho.
//       </p>
//       <p className="text-slate-400 text-sm">
//         Community driven approach ke saath hum modern equipment, safe environment aur motivation provide karte hain 
//         taaki har age group aur fitness level wala yahan comfortable feel kare.
//       </p>
//     </section>
//   );
// }